<template>
  <section class="login">
    <el-row :gutter="10">
      <el-col class="mainTitle" :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
        <router-link class="itemTitle" to="/" target="_self"><i class="el-icon-upload el-icon--right"></i>怪兽村</router-link>
        <!-- <a href="https://www.simyuan.com" target="_self">
          <el-button class="itemTitle"><i class="el-icon-upload el-icon--right"></i>怪兽博客</el-button>
        </a> -->
      </el-col>
      <el-col :xs="12" :sm="14" :md="14" :lg="16" :xl="16">

        <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal" @select="handleSelect"> 
          <el-submenu index="2">
            <template slot="title">物联网</template>
            <el-menu-item index="2-1">MQTT</el-menu-item>
            <el-menu-item index="2-2">Home Assistant</el-menu-item>
            <el-submenu index="2-4">              
            <template slot="title">其它</template>
              <el-menu-item index="2-4-1">message queue</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-submenu index="3" >
            <template slot="title">软件开发</template>
              <el-menu-item index="2-4-1">DotNet</el-menu-item>
              <el-menu-item index="2-4-2">Java</el-menu-item>
              <el-menu-item index="2-4-3">Javascript</el-menu-item>
          </el-submenu>
          <el-menu-item index="4"><a href="https://www.simyuan.com" target="_blank">生活购物</a></el-menu-item>
          <el-menu-item index="4"><router-link to="/main">摄影摄像</router-link></el-menu-item>
          <el-menu-item index="4"><router-link to="/about">关于我</router-link></el-menu-item>
        </el-menu>
      </el-col>
      <el-col class="query-input" :xs="4" :sm="4" :md="4" :lg="3" :xl="2">
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2">
        </el-input>
      </el-col>
      <el-col class="query" :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <el-button type="success" round>查询</el-button>
      </el-col>
    </el-row>
    <el-row class="highlight-bird highlight-phone">
      <el-col :span="12">
        <div class="grid-content ">
          <div class="col-md-8">
            <div class="intro">
              <h2>万物互联</h2>
              <p>这是一个互联网的世界，一个万物互联的时代，让我们连接起世界的每一个角落，从脚下开始。带你出发！<br></p>
              <el-button type="primary">查看</el-button>
            </div>
          </div>
          <div class="col-sm-4">
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content ">
          <div class="d-none d-md-block highlight-phone">
            <img src="../../public/img/DSC00675-2.jpg" class="image" >
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { link } from 'fs';

export default {
  name: 'login',
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      input2:'',
    }
  },
  components: {},
  watch: {},
  mounted() { },

  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>

<style scoped >
.mainTitle {  
  padding-top: 10px;
}
.itemTitle {
  font-size: 24px;
  font-weight: bold;
  margin-top: 5px;
  padding-top: 10px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 0px;
  min-height: 280px;
}

.query,
.query-input {
  margin-top: 12px;
}

.highlight-bird {
  border-radius: 4px;
  background-color: rgb(23, 112, 193);
}

.highlight-phone h2 {
  font-weight: bold;
  margin-bottom: 0px;
  line-height: 1.5;
  padding-top: 20px;
  margin-top: 30px;
  color: inherit;
}

.highlight-phone p {
  color: #dadee0;
}

.highlight-phone .intro {
  font-size: 18px;
  max-width: 600px;
  line-height: 1.5;
}

.col-md-8 {
  text-align: left;
  margin-left: 20%;
  margin-right: 10%;
  max-width: 95%;
  position: relative;
  width: 90%;
  padding-right: 15px;
  padding-left: 15px;
}
.image{
  width: 210px;
  position: relative;
  filter: brightness(103%) contrast(116%);
  display:table-cell; 
  margin:0 auto;
  margin-top: 32px;
}
</style>
